import { render, staticRenderFns } from "./ListsCountProvider.vue?vue&type=template&id=f6890d0e"
import script from "./ListsCountProvider.vue?vue&type=script&lang=ts"
export * from "./ListsCountProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports